<template>
  <div class="" style="color: rgb(255, 255, 255);min-height: inherit;display: flex;align-items: center;justify-content: space-evenly;flex-direction: column;height: 95%;">
    <div class="">
      <h3 aria-level="2" class="text-center text-uppercase ">
        <strong class="m-b" style="line-height: 30px;">Scan Science and Technology </strong><br>
        Contact Leading Edge Experts &amp; Companies
      </h3>
    </div>
    <div  class="m-b" style="font-size: medium;font-weight: 500;">
      <p class="m-b"><i class="fa fa-check"></i> Smart explore Technology and Science</p>
      <p class="m-b"><i class="fa fa-check"></i> Promote your own or your organisation's expertise</p>
      <p class="m-b"><i class="fa fa-check"></i> Pinpoint leading-edge experts among 10,000,000</p>
      <p class="m-b"><i class="fa fa-check"></i> Monitor specific keywords and experts</p>
    </div>
    <div class="text-center">
      <div style="font-size: larger;font-style: italic; font-weight: 500;"><i> No commitment, secure and confidential.</i></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RegisterLeftBox'
}
</script>



// WEBPACK FOOTER //
// src/components/register/RegisterLeftBox.vue